import { Form, Input, InputNumber } from "antd";
import { useIntl } from "react-intl";

import { FormFieldContainer } from "./styled";

export const NumberEditFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name={["property", "label", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "placeholder", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "requiredValidationText", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "min"]}
        label={intl.formatMessage({ id: "newFormField.numberMin" })}
      >
        <InputNumber style={{ maxWidth: 500 }} />
      </Form.Item>
      <Form.Item
        name={["property", "max"]}
        label={intl.formatMessage({ id: "newFormField.numberMax" })}
      >
        <InputNumber style={{ maxWidth: 500 }} />
      </Form.Item>
      <Form.Item
        name={["property", "precision"]}
        label={intl.formatMessage({ id: "newFormField.numberPrecision" })}
      >
        <InputNumber min="0" max="4" style={{ maxWidth: 500 }} />
      </Form.Item>
    </FormFieldContainer>
  );
};
